import styled from 'styled-components';
import { media, vars } from '$util/theme';
import { Card } from '$components/basic/Card';

export default styled(Card)`
  max-width: 626px;
  width: 100%;

  ${media.down('md')} {
    max-width: 100%;
    padding: 0;

    &.card-1 {
      background: transparent;
      box-shadow: none;
    }
  }
  .VrmLookup {
    .input-group {
      display: block;
      ${media.up('lg')} {
        display: flex;
        margin-bottom: 20px;
      }
    }
    .chat-us {
      text-align: center;
      p {
        color: ${vars.quantumverse.reskinColors.neutral300};
        margin-bottom: 5px;
      }
    }
  }
  .call-us {
    margin-top: 15px;
  }
`;
